<button
  type="button"
  class="credits-pill"
  [attr.aria-label]="
    'nav.credits aria' | translate: { count: creditsLabel() }
  "
  (click)="nav.studentCreditDetails()"
>
  <ut-icon
    class="credits-pill__icon"
    name="coins"
    [size]="18"
  ></ut-icon>
  <span class="credits-pill__count">{{ creditsLabel() }}</span>
</button>
